import { render } from "./AbilityLearn.vue?vue&type=template&id=0734ac8c"
import script from "./AbilityLearn.vue?vue&type=script&lang=js"
export * from "./AbilityLearn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__